(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1148);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./src/components/Footer/FooterBusiness.tsx
var FooterBusiness = __webpack_require__(1396);
// EXTERNAL MODULE: ./src/components/PageHeader/PageHeaderBusiness.tsx + 10 modules
var PageHeaderBusiness = __webpack_require__(3837);
// EXTERNAL MODULE: ./src/data/locales/id/business.json
var business = __webpack_require__(8593);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(1774);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(6562);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/modules/Home/popupStore.ts
var popupStore = __webpack_require__(5803);
// EXTERNAL MODULE: ./src/lib/gtag.ts
var gtag = __webpack_require__(5789);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(2631);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/Button/ButtonScheduleDemo.tsx
var ButtonScheduleDemo = __webpack_require__(8842);
;// CONCATENATED MODULE: ./src/modules/Business/HomeDescription.tsx









const HomeDescription = ()=>{
    const headingSectionDescription = business/* HomeDescription */.fJ;
    const headingTranslationButton = business/* Button */.zx;
    const { showPopupYoutube  } = (0,popupStore/* usePopupStoreFormSales */.p)((state)=>({
            showPopupYoutube: state.showPopupYoutube
        }));
    const onClickVideo = ()=>{
        (0,gtag/* pushDataLayer */.zz)({
            event: "cta-video"
        });
        showPopupYoutube();
    };
    const handleScroll = (e)=>{
        // first prevent the default behavior
        e.preventDefault();
        // get the href and remove everything before the hash (#)
        const href = e.currentTarget.href;
        const targetId = href.replace(/.*\#/, "");
        // get the element by id and use scrollIntoView
        const elem = document.getElementById(targetId);
        elem?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "start"
        });
    };
    const renderBusinessChip = (className, title, description)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `rounded-12 shadow-chip_total border border-white p-8 flex flex-col items-center justify-center h-fit ${className}`,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-black text-h4 text-violet_main_to_dark_purple_surface",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-light text-b1 2xl-max:text-b2",
                    children: description
                })
            ]
        });
    };
    const [isDesktop, setIsDesktop] = (0,react.useState)(null);
    const videoRef = (0,react.useRef)(null);
    const containerRefDesktop = (0,react.useRef)(null);
    const containerRefMobile = (0,react.useRef)(null);
    const progressBarRef = (0,react.useRef)(null);
    const [activeSection, setActiveSection] = (0,react.useState)(1);
    const [isPlaying, setIsPlaying] = (0,react.useState)(true);
    const [isMuted, setIsMuted] = (0,react.useState)(true);
    const [isBuffering, setIsBuffering] = (0,react.useState)(true);
    const [percentage, setPercentage] = (0,react.useState)(0);
    const sections = [
        {
            id: 1,
            start: 0,
            end: 123,
            no: "1",
            title: "Feedback Cerdas dari AI",
            description: "Dapatkan umpan balik khusus dari AI yang dirancang untuk membantu Anda mengasah kompetensi dan meningkatkan performa kerja."
        },
        {
            id: 2,
            start: 123,
            end: 153,
            no: "2",
            title: "Diskusi Profesional yang Terarah",
            description: "AI menjaga percakapan tetap fokus pada topik profesional. Jika ada pertanyaan di luar konteks pekerjaan, AI akan mengarahkan kembali ke topik yang relevan."
        },
        {
            id: 3,
            start: 153,
            end: 213,
            no: "3",
            title: "Tingkatkan Kinerja dengan AI",
            description: "Optimalkan performa Anda dengan wawasan AI untuk mendorong produktivitas dan hasil kerja yang maksimal."
        }
    ];
    const handlePlayVideo = ()=>{
        setIsPlaying(true);
        setTimeout(()=>{
            setIsMuted(false);
        }, 500);
    };
    const handlePauseVideo = ()=>{
        setIsMuted(true);
        setIsPlaying(false);
    };
    const handleBuffering = ()=>{
        setIsBuffering(true);
    };
    const handleBufferingEnd = ()=>{
        setIsBuffering(false);
    };
    const handleVideoReady = ()=>{
        handleBufferingEnd();
        handlePlayVideo();
        setTimeout(()=>{
            handleBuffering();
            handlePauseVideo();
        }, 500);
        setTimeout(()=>{
            handleBufferingEnd();
            handlePlayVideo();
        }, 1000);
    };
    (0,react.useEffect)(()=>{
        const video = videoRef.current;
        setIsPlaying(false);
        setIsMuted(true);
        if (video) {
            const section = sections.find((s)=>s.id === activeSection);
            if (section) {
                video.seekTo(section.start, "seconds");
                setIsPlaying(true);
                setTimeout(()=>{
                    setIsMuted(false);
                }, 500);
            }
        }
        return ()=>{
            setIsPlaying(false);
            setIsMuted(true);
        };
    }, [
        activeSection
    ]);
    const handleProgress = (state)=>{
        const progress = state.played * 100;
        setPercentage(progress);
        const currentTime = state.played * sections[sections.length - 1].end;
        sections.forEach((section)=>{
            if (currentTime >= section.start && currentTime < section.end) {
                if (activeSection !== section.id) {
                    setActiveSection(section.id);
                }
            }
        });
    };
    const observeVisibility = (ref)=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) {
                setIsPlaying(true);
                setTimeout(()=>{
                    setIsMuted(false);
                }, 500);
            } else {
                setIsPlaying(false);
                setIsMuted(true);
            }
        }, {
            threshold: 0.1
        });
        if (ref.current) {
            observer.observe(ref.current);
        }
        return ()=>{
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    };
    const player = /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        ref: videoRef,
        url: "https://s.gokampus.com/vid/goKampus+AI+Advisor+-+Demo.mp4",
        controls: false,
        playing: isPlaying,
        onPause: handlePauseVideo,
        onPlay: handlePlayVideo,
        onBuffer: handleBuffering,
        onBufferEnd: handleBufferingEnd,
        onReady: handleVideoReady,
        onProgress: handleProgress,
        muted: isMuted,
        // muted={true}
        loop: true,
        progressInterval: 100,
        playsinline: true,
        width: "100%",
        height: "100%"
    });
    (0,react.useEffect)(()=>{
        const unobserveDesktop = observeVisibility(containerRefDesktop);
        const unobserveMobile = observeVisibility(containerRefMobile);
        const resizeHandler = ()=>{
            if (window.innerWidth >= 1024) {
                setIsDesktop(true);
            } else if (window.innerWidth < 1024) {
                setIsDesktop(false);
            }
        };
        resizeHandler();
        window.addEventListener("resize", resizeHandler);
        return ()=>{
            unobserveDesktop();
            unobserveMobile();
            window.removeEventListener("resize", resizeHandler);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "home-description z-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
            useAuto: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 xl-max:grid-cols-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-20 text-left items-center mb-28 md:px-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                dangerouslySetInnerHTML: {
                                    __html: headingSectionDescription.title
                                },
                                className: "font-black text-center text-h3 lg:text-h2 lg:whitespace-nowrap"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                //@ts-ignore
                                href: "#home-packets",
                                onClick: handleScroll,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: headingSectionDescription.description
                                    },
                                    className: "font-light text-b1 lg:text-h4 text-center"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center items-center md:gap-8 sm-max:flex-col sm-max:items-start hidden lg:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonScheduleDemo/* default */.Z, {
                                    className: "!h-40",
                                    id: "cta-header"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex justify-center items-center lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonScheduleDemo/* default */.Z, {
                                    className: "!h-40",
                                    id: "cta-header"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-[8px] lg:flex-row lg:gap-50 justify-start items-start lg:justify-center lg:items-center mt-12 mb-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-[4px] lg:gap-8 justify-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/star-landing.svg",
                                                alt: "star",
                                                className: "w-[16px] h-[16px] lg:w-[20px] lg:h-[20px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-violet_main_to_dark_purple_surface text-b2 lg:text-b1 font-light",
                                                children: "Integrasi Mudah di Berbagai Platform"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-[4px] lg:gap-8 justify-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/star-landing.svg",
                                                alt: "star",
                                                className: "w-[16px] h-[16px] lg:w-[20px] lg:h-[20px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-violet_main_to_dark_purple_surface text-b2 lg:text-b1 font-light",
                                                children: "Satu Harga untuk Jumlah Pembelajar Tanpa Batas"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: containerRefDesktop,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full rounded-xl overflow-hidden",
                                    children: player
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute top-0 left-0 w-full h-full flex justify-center items-center cursor-pointer",
                                    onClick: ()=>setIsPlaying((prev)=>!prev),
                                    children: isPlaying ? isBuffering ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-44 h-44 border-4 border-violet_main border-solid border-t-transparent rounded-full animate-spin"
                                    }) : "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/icon-play-grey.svg",
                                        alt: "play"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute px-[12px] bottom-60 w-full z-10",
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-around",
                                        marginTop: "20px"
                                    },
                                    children: sections.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            onClick: ()=>setActiveSection(section.id),
                                            style: {
                                                padding: "10px",
                                                borderRadius: "8px",
                                                color: "white",
                                                width: "32%",
                                                textAlign: "center",
                                                opacity: activeSection === section.id ? 1 : 0.6,
                                                transition: "opacity 0.5s",
                                                background: activeSection !== section.id && "linear-gradient(111.61deg, rgba(255, 255, 255, 0.76) 15.17%, rgba(255, 255, 255, 0.64) 95.84%)",
                                                backdropFilter: activeSection !== section.id && "blur(13px)",
                                                boxShadow: activeSection !== section.id && "-3px 11px 41px 0px #9F9F9F26"
                                            },
                                            className: `${activeSection === section.id && "bg-violet_main_to_dark_purple_surface"} rounded-xl cursor-pointer`,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-center items-center gap-8 mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: `text-h4 font-bold ${activeSection === section.id ? "text-white" : "text-neutral-80"}`,
                                                            children: section.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: `text-b2 font-medium text-black rounded-full bg-white ${activeSection === section.id ? "w-20 h-20" : "w-22 h-22 border border-black"}`,
                                                            children: section.no
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: `text-b1 font-light ${activeSection === section.id ? "text-white" : "text-neutral-80"}`,
                                                    children: section.description
                                                })
                                            ]
                                        }, section.id))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute w-full h-[10px] px-[20px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative bottom-32 w-full h-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-0 left-0 right-0 mx-5 bg-violet_main_to_dark_purple_surface rounded-xl z-30",
                                                ref: progressBarRef,
                                                style: {
                                                    height: "10px",
                                                    width: `${percentage}%`,
                                                    transition: "width 0.1s linear"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-0 left-0 right-0 mx-5 w-auto h-[10px] bg-white/60 rounded-xl z-20"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: containerRefMobile,
                        className: "bg-violet_main_to_dark_purple_surface rounded-[12px] overflow-hidden lg:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    position: "relative",
                                    width: "100%",
                                    display: "inline-block"
                                },
                                children: [
                                    player,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 left-0 w-full h-full flex justify-center items-center cursor-pointer",
                                        onClick: ()=>setIsPlaying((prev)=>!prev),
                                        children: isPlaying ? isBuffering ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-44 h-44 border-4 border-violet_main border-solid border-t-transparent rounded-full animate-spin"
                                        }) : "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/icon-play-grey.svg",
                                            alt: "play"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-violet_main_to_dark_purple_surface",
                                        ref: progressBarRef,
                                        style: {
                                            position: "absolute",
                                            bottom: "0",
                                            left: "0",
                                            height: "4px",
                                            width: `${percentage}%`,
                                            transition: "width 0.1s linear"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-start p-[8px] gap-[6px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex gap-[8px]",
                                        children: sections.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: ()=>setActiveSection(section.id),
                                                className: `flex justify-center items-center rounded-full z-40
                        ${activeSection === section.id ? "bg-white text-violet_main" : "bg-transparent text-white"}
                        w-[20px] h-[20px] text-xs leading-none font-medium border border-white
                        pt-[1px]`,
                                                children: section.no
                                            }, section.id))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-b1 font-black text-white",
                                        children: sections[activeSection - 1].title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-b2 font-light text-white",
                                        children: sections[activeSection - 1].description
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/IconBooks.tsx

const IconBooks = ({ size =32 , color ="#FFFFFF"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M29.96 25.0933L28.6267 19.9467L24.4267 4.49333C24.3359 4.15245 24.1138 3.86143 23.8089 3.684C23.504 3.50657 23.1412 3.45718 22.8 3.54667L17.64 4.88C17.5169 4.74353 17.3668 4.63399 17.1993 4.55827C17.0318 4.48255 16.8505 4.44228 16.6667 4.44H3.33333C2.97971 4.44 2.64057 4.58048 2.39052 4.83052C2.14048 5.08057 2 5.41971 2 5.77333V27.1067C2 27.4603 2.14048 27.7994 2.39052 28.0495C2.64057 28.2995 2.97971 28.44 3.33333 28.44H16.6667C17.0203 28.44 17.3594 28.2995 17.6095 28.0495C17.8595 27.7994 18 27.4603 18 27.1067V16.44L20.9333 27.4C21.0115 27.6909 21.1858 27.9467 21.4279 28.1259C21.67 28.3051 21.9657 28.397 22.2667 28.3867C22.3819 28.3998 22.4981 28.3998 22.6133 28.3867L29.0533 26.6667C29.2236 26.6211 29.3831 26.5423 29.5227 26.4348C29.6623 26.3272 29.7792 26.193 29.8667 26.04C30.0073 25.745 30.0403 25.4101 29.96 25.0933ZM8.62667 25.8267H4.62667V23.16H8.62667V25.8267ZM8.62667 20.4933H4.62667V12.4933H8.62667V20.4933ZM8.62667 9.82667H4.62667V7.16H8.62667V9.82667ZM15.2933 25.8267H11.2933V23.16H15.2933V25.8267ZM15.2933 20.4933H11.2933V12.4933H15.2933V20.4933ZM15.2933 9.82667H11.2933V7.16H15.2933V9.82667ZM18.2933 7.50667L22.16 6.46667L22.8533 9.04L18.9867 10.08L18.2933 7.50667ZM21.7467 20.3867L19.68 12.6533L23.5467 11.6133L25.6133 19.3467L21.7467 20.3867ZM23.08 25.5333L22.3867 22.96L26.2533 21.92L26.9467 24.4933L23.08 25.5333Z",
            fill: color
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/IconElectric.tsx

const IconElectric = ({ size =32 , color ="#FFFFFF"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17.937 1.51643L17.9718 1.52711C18.0294 1.55111 18.0746 1.58771 18.1053 1.62838C18.1412 1.67592 18.1569 1.72784 18.1569 1.77652V1.77662V10.6655V12.1655H19.6569H26.9707H26.9713C27.0398 12.1655 27.1044 12.1839 27.1577 12.2153C27.2107 12.2465 27.2481 12.2878 27.2709 12.3303C27.2935 12.3724 27.3023 12.4164 27.2994 12.4585C27.2966 12.5005 27.282 12.5446 27.2526 12.5857C27.2524 12.5859 27.2523 12.5861 27.2522 12.5862L14.4535 30.3633L14.4523 30.365C14.4175 30.4135 14.3622 30.457 14.2894 30.4811C14.2162 30.5054 14.1356 30.5063 14.0615 30.4836C13.9877 30.4611 13.9309 30.4185 13.8946 30.3703C13.8587 30.3227 13.843 30.2708 13.843 30.2221V30.2211V21.3322V19.8322H12.343H5.02922H5.02857C4.96009 19.8322 4.89549 19.8138 4.84222 19.7824C4.78926 19.7512 4.75179 19.7099 4.72901 19.6674C4.70644 19.6253 4.69765 19.5813 4.70046 19.5392C4.70328 19.497 4.71804 19.4527 4.74771 19.4115L17.5462 1.63466C17.5811 1.58618 17.6364 1.54277 17.7092 1.51875L17.2393 0.0942602L17.7092 1.51875C17.7824 1.49461 17.863 1.49372 17.937 1.51643Z",
            stroke: color,
            strokeWidth: "3"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/IconCurrency.tsx

const IconCurrency = ({ size =32 , color ="#FFFFFF"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.9999 1.33337C13.0991 1.33337 10.2635 2.19356 7.85156 3.80515C5.43964 5.41675 3.55978 7.70737 2.44969 10.3873C1.33961 13.0673 1.04916 16.0163 1.61507 18.8614C2.18099 21.7064 3.57786 24.3198 5.62903 26.3709C7.6802 28.4221 10.2935 29.819 13.1386 30.3849C15.9837 30.9508 18.9326 30.6604 21.6126 29.5503C24.2926 28.4402 26.5832 26.5603 28.1948 24.1484C29.8064 21.7365 30.6666 18.9008 30.6666 16C30.6666 12.1102 29.1214 8.37967 26.3708 5.62914C23.6203 2.87861 19.8898 1.33337 15.9999 1.33337ZM15.9999 28C13.6265 28 11.3065 27.2963 9.33308 25.9777C7.35969 24.6591 5.82162 22.785 4.91337 20.5922C4.00512 18.3995 3.76748 15.9867 4.2305 13.659C4.69352 11.3312 5.83641 9.19299 7.51464 7.51476C9.19287 5.83653 11.3311 4.69364 13.6588 4.23062C15.9866 3.76759 18.3994 4.00523 20.5921 4.91349C22.7848 5.82174 24.659 7.35981 25.9776 9.3332C27.2961 11.3066 27.9999 13.6267 27.9999 16C27.9999 19.1826 26.7356 22.2349 24.4852 24.4853C22.2348 26.7358 19.1825 28 15.9999 28Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4466 19.7386C10.2865 19.7386 10.1518 19.684 10.0427 19.5748C9.93349 19.4656 9.8789 19.331 9.8789 19.1709V11.7802C9.8789 11.6128 9.93349 11.4782 10.0427 11.3763C10.1518 11.2671 10.2865 11.2126 10.4466 11.2126H12.4116C12.9574 11.2126 13.4414 11.329 13.8635 11.5619C14.2856 11.7875 14.6131 12.1005 14.846 12.5007C15.0862 12.901 15.2063 13.3668 15.2063 13.8981C15.2063 14.4221 15.0753 14.8842 14.8133 15.2845C14.5513 15.6775 14.1947 15.9759 13.7434 16.1797L15.4137 18.8652C15.5447 19.0763 15.5629 19.2764 15.4683 19.4656C15.3737 19.6476 15.2099 19.7386 14.977 19.7386C14.766 19.7386 14.6022 19.6476 14.4858 19.4656L12.6081 16.4526C12.5426 16.4526 12.4771 16.4526 12.4116 16.4526H11.0142V19.1709C11.0142 19.331 10.9597 19.4656 10.8505 19.5748C10.7486 19.684 10.614 19.7386 10.4466 19.7386ZM11.0142 15.4046H12.4116C12.9065 15.4046 13.3141 15.2663 13.6343 14.9898C13.9545 14.7059 14.1146 14.342 14.1146 13.8981C14.1146 13.4178 13.9545 13.0247 13.6343 12.7191C13.3141 12.4134 12.9065 12.2606 12.4116 12.2606H11.0142V15.4046Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.7699 22.2931C17.6098 22.2931 17.4752 22.2385 17.366 22.1293C17.2641 22.0275 17.2132 21.8965 17.2132 21.7363V16.7583C17.2205 16.1833 17.3551 15.6666 17.6171 15.2081C17.8791 14.7496 18.2357 14.3893 18.687 14.1273C19.1382 13.8581 19.6476 13.7234 20.2153 13.7234C20.7903 13.7234 21.3033 13.8581 21.7546 14.1273C22.2058 14.3893 22.5624 14.7496 22.8244 15.2081C23.0937 15.6666 23.2283 16.1833 23.2283 16.7583C23.2283 17.3332 23.1046 17.85 22.8572 18.3085C22.617 18.7597 22.2859 19.12 21.8637 19.3892C21.4416 19.6512 20.9649 19.7822 20.4336 19.7822C20.0042 19.7822 19.6076 19.6949 19.2437 19.5202C18.8871 19.3383 18.5814 19.0945 18.3267 18.7888V21.7363C18.3267 21.8965 18.2758 22.0275 18.1739 22.1293C18.072 22.2385 17.9373 22.2931 17.7699 22.2931ZM20.2153 18.7997C20.5865 18.7997 20.9176 18.7124 21.2087 18.5377C21.4998 18.3558 21.7291 18.112 21.8965 17.8063C22.0712 17.4933 22.1585 17.144 22.1585 16.7583C22.1585 16.3653 22.0712 16.0159 21.8965 15.7103C21.7291 15.3973 21.4998 15.1535 21.2087 14.9789C20.9176 14.7969 20.5865 14.7059 20.2153 14.7059C19.8514 14.7059 19.5203 14.7969 19.2219 14.9789C18.9308 15.1535 18.7015 15.3973 18.5341 15.7103C18.3667 16.0159 18.283 16.3653 18.283 16.7583C18.283 17.144 18.3667 17.4933 18.5341 17.8063C18.7015 18.112 18.9308 18.3558 19.2219 18.5377C19.5203 18.7124 19.8514 18.7997 20.2153 18.7997Z",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.4683 19.4656C15.3737 19.6476 15.2099 19.7386 14.977 19.7386C14.766 19.7386 14.6022 19.6476 14.4858 19.4656L12.6081 16.4526H11.0142V19.1709C11.0142 19.331 10.9597 19.4656 10.8505 19.5748C10.7486 19.684 10.614 19.7386 10.4466 19.7386C10.2865 19.7386 10.1518 19.684 10.0427 19.5748C9.93349 19.4656 9.8789 19.331 9.8789 19.1709V11.7802C9.8789 11.6128 9.93349 11.4782 10.0427 11.3763C10.1518 11.2671 10.2865 11.2126 10.4466 11.2126H12.4116C12.9574 11.2126 13.4414 11.329 13.8635 11.5619C14.2856 11.7875 14.6131 12.1005 14.846 12.5007C15.0862 12.901 15.2063 13.3668 15.2063 13.8981C15.2063 14.4221 15.0753 14.8842 14.8133 15.2845C14.6508 15.5283 14.452 15.7357 14.2166 15.9067C14.0726 16.0113 13.9148 16.1023 13.7434 16.1797L15.4137 18.8652C15.5447 19.0763 15.5629 19.2764 15.4683 19.4656ZM14.5055 16.3712L15.8774 18.5769C16.0879 18.9161 16.1521 19.319 15.9567 19.7097L15.9528 19.7175C15.861 19.8941 15.7241 20.0451 15.5398 20.1475C15.3594 20.2477 15.1642 20.2844 14.9772 20.2844C14.5748 20.2844 14.2402 20.0941 14.0262 19.7599L14.0227 19.7543L12.3053 16.9984H11.5603V19.1709C11.5603 19.4667 11.4545 19.7395 11.2432 19.9542C11.0259 20.183 10.7423 20.2844 10.4468 20.2844C10.1479 20.2844 9.87258 20.1765 9.65688 19.9608C9.44119 19.7451 9.33326 19.4698 9.33326 19.1709V11.7802C9.33326 11.4847 9.43463 11.2011 9.66346 10.9838C9.87816 10.7725 10.1509 10.6667 10.4468 10.6667H12.4118C13.0362 10.6667 13.612 10.8003 14.1242 11.0822C14.6299 11.3532 15.0313 11.7348 15.3162 12.2231C15.6127 12.7186 15.7523 13.2831 15.7523 13.8981C15.7523 14.5177 15.5959 15.0859 15.2702 15.5834L15.2677 15.5873C15.0606 15.8979 14.8052 16.1593 14.5055 16.3712ZM11.5603 14.8588H12.4118C12.7975 14.8588 13.0707 14.7543 13.275 14.5789C13.4717 14.4035 13.569 14.1912 13.569 13.8981C13.569 13.5528 13.4601 13.3072 13.2576 13.1139C13.0512 12.9169 12.7843 12.8064 12.4118 12.8064H11.5603V14.8588ZM12.4116 15.4046C12.9065 15.4046 13.3141 15.2663 13.6343 14.9898C13.9545 14.7059 14.1146 14.342 14.1146 13.8981C14.1146 13.4178 13.9545 13.0247 13.6343 12.7191C13.3141 12.4134 12.9065 12.2606 12.4116 12.2606H11.0142V15.4046H12.4116ZM16.6676 16.7514C16.6759 16.0922 16.8314 15.4833 17.1434 14.9373C17.452 14.3973 17.8761 13.9677 18.4103 13.6569C18.9521 13.3343 19.5587 13.1776 20.2155 13.1776C20.8782 13.1776 21.4887 13.3336 22.0317 13.6569C22.5649 13.9672 22.9885 14.3958 23.2969 14.9345C23.6183 15.4828 23.7744 16.0954 23.7744 16.7583C23.7744 17.4136 23.6327 18.0205 23.3385 18.5663C23.0551 19.0981 22.6601 19.5287 22.1575 19.8494L22.1518 19.853C21.6372 20.1724 21.0595 20.3281 20.4338 20.3281C19.928 20.3281 19.45 20.2246 19.0077 20.0123L19.0017 20.0094L18.9958 20.0064C18.9542 19.9852 18.9132 19.9633 18.8727 19.9406V21.7363C18.8727 22.0206 18.7781 22.2936 18.5666 22.5086C18.3493 22.7375 18.0657 22.8389 17.7701 22.8389C17.4713 22.8389 17.1959 22.731 16.9803 22.5153C16.7642 22.2992 16.6675 22.0236 16.6675 21.7363L16.6676 16.7514ZM18.1739 22.1293C18.2758 22.0275 18.3267 21.8965 18.3267 21.7363V18.7888C18.4882 18.9826 18.6703 19.1515 18.8727 19.2955C18.9896 19.3787 19.1132 19.4536 19.2437 19.5202C19.6076 19.6949 20.0042 19.7822 20.4336 19.7822C20.9649 19.7822 21.4416 19.6512 21.8637 19.3892C22.2859 19.12 22.617 18.7597 22.8572 18.3085C23.1046 17.85 23.2283 17.3332 23.2283 16.7583C23.2283 16.1833 23.0937 15.6666 22.8244 15.2081C22.5624 14.7496 22.2058 14.3893 21.7546 14.1273C21.3033 13.8581 20.7903 13.7234 20.2153 13.7234C19.6476 13.7234 19.1382 13.8581 18.687 14.1273C18.2357 14.3893 17.8791 14.7496 17.6171 15.2081C17.3551 15.6666 17.2205 16.1833 17.2132 16.7583V21.7363C17.2132 21.8965 17.2641 22.0275 17.366 22.1293C17.4752 22.2385 17.6098 22.2931 17.7699 22.2931C17.9373 22.2931 18.072 22.2385 18.1739 22.1293ZM19.2219 14.9789C18.9308 15.1535 18.7015 15.3973 18.5341 15.7103C18.3667 16.0159 18.283 16.3653 18.283 16.7583C18.283 17.144 18.3667 17.4933 18.5341 17.8063C18.7015 18.112 18.9308 18.3558 19.2219 18.5377C19.5203 18.7124 19.8514 18.7997 20.2153 18.7997C20.5865 18.7997 20.9176 18.7124 21.2087 18.5377C21.4998 18.3558 21.7291 18.112 21.8965 17.8063C22.0712 17.4933 22.1585 17.144 22.1585 16.7583C22.1585 16.3653 22.0712 16.0159 21.8965 15.7103C21.7291 15.3973 21.4998 15.1535 21.2087 14.9789C20.9176 14.7969 20.5865 14.7059 20.2153 14.7059C19.8514 14.7059 19.5203 14.7969 19.2219 14.9789ZM19.5046 18.0706C19.7132 18.1911 19.9462 18.2539 20.2155 18.2539C20.4953 18.2539 20.7263 18.1897 20.9239 18.0722C21.1324 17.9409 21.2956 17.7675 21.4179 17.5441L21.42 17.5403C21.5459 17.3148 21.6129 17.0582 21.6129 16.7583C21.6129 16.449 21.545 16.195 21.4228 15.9811L21.419 15.9744L21.4154 15.9677C21.2923 15.7377 21.1306 15.5684 20.9281 15.4469L20.9196 15.4418C20.7223 15.3185 20.493 15.2518 20.2155 15.2518C19.9475 15.2518 19.7154 15.3173 19.5062 15.4449L19.5029 15.4469C19.3004 15.5684 19.1387 15.7377 19.0156 15.9677L19.0131 15.9724C18.8951 16.1879 18.8291 16.445 18.8291 16.7583C18.8291 17.0611 18.8938 17.3201 19.0144 17.5465C19.1361 17.7679 19.298 17.94 19.5046 18.0706Z",
                fill: color
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(1097);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(3906);
// EXTERNAL MODULE: ./src/lib/device.ts
var device = __webpack_require__(9799);
;// CONCATENATED MODULE: ./src/modules/Business/HomeBenefit.tsx












const HomeBenefit = ()=>{
    const headingSectionBenefit = business/* HomeBenefit */.Yt;
    const router = (0,next_router.useRouter)();
    const SLIDE_DURATION = 7000; // Duration for each slide in milliseconds
    const { showPopupFormSales  } = (0,popupStore/* usePopupStoreFormSales */.p)((state)=>({
            showPopupFormSales: state.showPopupFormSales
        }));
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const [previousIndex, setPreviousIndex] = (0,react.useState)(0);
    const [progress, setProgress] = (0,react.useState)(()=>Array(headingSectionBenefit.content.length).fill(0));
    const [isTransitioning, setIsTransitioning] = (0,react.useState)(false);
    // Handle slide transitions
    (0,react.useEffect)(()=>{
        const slideInterval = setInterval(()=>{
            setIsTransitioning(true);
            setPreviousIndex(activeIndex);
            setActiveIndex((prevIndex)=>{
                const nextIndex = prevIndex === headingSectionBenefit.content.length - 1 ? 0 : prevIndex + 1;
                return nextIndex;
            });
            // Reset transition state after animation completes
            setTimeout(()=>{
                setIsTransitioning(false);
            }, 500); // Match this with CSS transition duration
        }, SLIDE_DURATION);
        return ()=>clearInterval(slideInterval);
    }, [
        headingSectionBenefit.content.length,
        activeIndex
    ]);
    // Handle progress bar animation
    (0,react.useEffect)(()=>{
        const startTime = Date.now();
        const progressInterval = setInterval(()=>{
            const elapsedTime = Date.now() - startTime;
            const progressValue = Math.min(elapsedTime / SLIDE_DURATION * 100, 100);
            setProgress((prev)=>prev.map((_, idx)=>idx === activeIndex ? progressValue : 0));
            if (progressValue >= 100) {
                clearInterval(progressInterval);
            }
        }, 16);
        return ()=>clearInterval(progressInterval);
    }, [
        activeIndex
    ]);
    const getProgressBarStyles = (index)=>{
        if (isTransitioning) {
            if (index === previousIndex) {
                return {
                    transform: "translateX(100%)",
                    opacity: 0,
                    transition: "transform 500ms ease-in-out, opacity 500ms ease-in-out"
                };
            } else if (index === activeIndex) {
                return {
                    transform: "translateX(0)",
                    opacity: 1,
                    transition: "transform 500ms ease-in-out, opacity 500ms ease-in-out"
                };
            }
        }
        return {
            transform: "translateX(0)",
            opacity: index === activeIndex ? 1 : 0.3
        };
    };
    const handleScroll = (id)=>{
        const elem = document.getElementById(id);
        if (!elem) return;
        const offset = -50;
        const y = elem.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    };
    const renderDescription = (contents, isImageLeft, isTwoColumn)=>{
        let buttonItem;
        let secondButtonItem;
        if (contents.icon === "book") {
            buttonItem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "!text-b1 hg-max:!text-b2 !h-40 min-w-[200px]",
                variant: "secondary_transparant",
                tabIndex: 0,
                onClick: ()=>{
                    (0,gtag/* pushDataLayer */.zz)({
                        event: "benefit-install"
                    });
                    showPopupFormSales("");
                },
                children: contents.buttonDesc
            });
        } else if (contents.icon === "electric") {
            buttonItem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "!text-b1 hg-max:!text-b2 !h-40 min-w-[200px]",
                variant: "secondary_transparant",
                tabIndex: 0,
                onClick: ()=>{
                    (0,gtag/* pushDataLayer */.zz)({
                        event: "benefit-report"
                    });
                    showPopupFormSales("");
                },
                children: contents.buttonDesc
            });
        } else if (contents.icon === "currency") {
            buttonItem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "!text-b1 hg-max:!text-b2 !h-40 min-w-[200px]",
                variant: "secondary_transparant",
                tabIndex: 0,
                onClick: ()=>{
                    handleScroll("home-packets");
                },
                children: contents.buttonDesc
            });
        } else if (Array.isArray(contents)) {
            buttonItem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "!text-b1 hg-max:!text-b2 !h-40 min-w-[200px]",
                variant: "secondary_transparant",
                tabIndex: 0,
                onClick: ()=>{
                    (0,gtag/* pushDataLayer */.zz)({
                        event: "benefit-report"
                    });
                    showPopupFormSales("");
                },
                children: contents[0].buttonDesc
            });
            secondButtonItem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "!text-b1 hg-max:!text-b2 !h-40 min-w-[200px]",
                variant: "secondary_transparant",
                tabIndex: 0,
                onClick: ()=>{
                    (0,gtag/* pushDataLayer */.zz)({
                        event: "benefit-report"
                    });
                    showPopupFormSales("");
                },
                children: contents[1].buttonDesc
            });
        }
        function useDirectionalCarousel(iconType, matchType) {
            const [index, setIndex] = (0,react.useState)(0);
            const [dir, setDir] = (0,react.useState)("right");
            (0,react.useEffect)(()=>{
                if (iconType !== matchType) return;
                const interval = setInterval(()=>{
                    setIndex((prevIndex)=>{
                        if (dir === "right") {
                            if (prevIndex >= 1) {
                                setDir("left");
                                return prevIndex; // tetap di posisi sekarang, karena sudah mentok
                            }
                            return prevIndex + 1;
                        } else {
                            if (prevIndex <= 0) {
                                setDir("right");
                                return prevIndex;
                            }
                            return prevIndex - 1;
                        }
                    });
                }, 3500);
                return ()=>clearInterval(interval);
            }, [
                dir,
                iconType,
                matchType
            ]);
            (0,react.useEffect)(()=>{
                setIndex(0);
                setDir("right");
            }, [
                iconType
            ]);
            return [
                index,
                dir
            ];
        }
        const [activeImageIndex, setActiveImageIndex] = useDirectionalCarousel(contents?.icon, "electric");
        const [activeImageIndex2, setActiveImageIndex2] = useDirectionalCarousel(contents?.icon, "currency");
        const [showSecondImage, setShowSecondImage] = (0,react.useState)(false);
        (0,react.useEffect)(()=>{
            if (contents.icon === "book" && activeIndex === headingSectionBenefit.content.indexOf(contents)) {
                const timer = setTimeout(()=>{
                    setShowSecondImage(true);
                }, 1000);
                return ()=>clearTimeout(timer);
            } else {
                setShowSecondImage(false);
            }
        }, [
            contents,
            activeIndex
        ]);
        const isDesktop = (0,device/* useIsDesktop */.Ce)();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-[2fr_3fr] gap-16 rounded-12 lg-max:grid-cols-1 pt-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-full flex flex-col gap-16 justify-center items-start rounded-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-12 lg:gap-24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-48",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-purple-60 w-48 h-48 flex justify-center rounded-full items-center",
                                        children: {
                                            book: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBooks, {}),
                                            electric: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconElectric, {}),
                                            currency: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCurrency, {})
                                        }[contents.icon]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "w-full text-start text-violet_main_to_dark_purple_surface lg:text-h3 font-bold text-b1 py-4",
                                    children: contents.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: contents.description
                            },
                            className: "text-start text-neutral-80 text-b1 font-light sm-max:text-b2"
                        }),
                        buttonItem
                    ]
                }, contents.icon),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `w-full flex relative lg-max:order-first ${isDesktop ? "py-40 px-40" : "px-24 py-24"} ${contents.icon == "book" ? "pr-[0px]" : ""} rounded-3xl bg-violet_main`,
                    children: contents.icon == "book" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-[100%] flex gap-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "w-[27%] object-cover border-[4px] border-[#000] rounded-[12px]",
                                    src: contents.imageUrl[0],
                                    alt: contents.imageAlt
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: `w-[73%] object-cover transition-transform duration-1000 ease-in-out border-[4px] border-[#000] rounded-[12px]`,
                                    style: {
                                        transform: `translateX(${showSecondImage ? "0" : "100%"})`
                                    },
                                    src: contents.imageUrl[1],
                                    alt: contents.imageAlt
                                })
                            ]
                        })
                    }) : contents.icon == "electric" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex transition-transform duration-500 ease-in-out h-full",
                            style: {
                                transform: `translateX(-${activeImageIndex * 100}%)`,
                                width: "300%"
                            },
                            children: [
                                contents.imageUrl[0],
                                contents.imageUrl[1]
                            ].map((image, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full flex-shrink-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "w-[33%] object-cover border-[4px] border-[#000] rounded-[12px]",
                                        src: image,
                                        alt: `${contents.imageAlt} ${index + 1}`
                                    })
                                }, index))
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex transition-transform duration-500 ease-in-out h-full",
                            style: {
                                transform: `translateX(-${activeImageIndex2 * 100}%)`,
                                width: "300%"
                            },
                            children: [
                                contents.imageUrl[0],
                                contents.imageUrl[1]
                            ].map((image, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full flex-shrink-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "w-[33%] object-cover border-[4px] border-[#000] rounded-[12px]",
                                        src: image,
                                        alt: `${contents.imageAlt} ${index + 1}`
                                    })
                                }, index))
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "home-benefit",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
            useAuto: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "gap-24 justify-center text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-h3 font-black text-neutral-80 sm-max:text-h4",
                                children: headingSectionBenefit.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-h4 font-light text-neutral-70 sm-max:text-b1",
                                children: headingSectionBenefit.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-12 justify-between items-center pt-44",
                        children: headingSectionBenefit.content.map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative h-4 bg-light_neutral10_to_dark_neutral50 rounded-full overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-full bg-violet_main_to_dark_purple_surface absolute inset-0",
                                        style: {
                                            width: `${progress[index]}%`,
                                            ...getProgressBarStyles(index)
                                        }
                                    })
                                })
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overflow-hidden h-auto w-full",
                        children: headingSectionBenefit.content.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${index === activeIndex ? "translate-y-0 opacity-100 relative" : "translate-y-full opacity-0 absolute"} inset-0 transition-transform duration-700 ease-in-out`,
                                children: renderDescription(item, false, false)
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Tabs/TabsCustom.tsx + 1 modules
var TabsCustom = __webpack_require__(9183);
// EXTERNAL MODULE: ./node_modules/react-spinners/esm/MoonLoader.js
var MoonLoader = __webpack_require__(3173);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(7601);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(8951);
// EXTERNAL MODULE: ./src/components/Card/CardCourseWithLesson.tsx + 3 modules
var CardCourseWithLesson = __webpack_require__(4868);
;// CONCATENATED MODULE: ./src/modules/Business/HomeAccess.tsx












swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_
]);
const HomeAccess = ()=>{
    const headingSectionAccess = business/* HomeAccess */.Iv;
    const [selectedItem, setSelectedItem] = (0,react.useState)("");
    const [allCategories, setAllCategories] = (0,react.useState)([]);
    const [allCourse, setAllCourse] = (0,react.useState)(null);
    const [isLoading, setLoading] = (0,react.useState)(false);
    const [allData, setAllData] = (0,react.useState)([]);
    const { showPopupFormSales  } = (0,popupStore/* usePopupStoreFormSales */.p)((state)=>({
            showPopupFormSales: state.showPopupFormSales
        }));
    (0,react.useEffect)(()=>{
        getCoursesByCategory();
    }, []);
    const onSelectItem = (item)=>{
        setSelectedItem(item.name);
    };
    const onClickSeeMoreCourses = ()=>{
        (0,gtag/* pushDataLayer */.zz)({
            event: "course-access-home-see-more"
        });
        showPopupFormSales("");
    };
    const getCoursesByCategory = ()=>{
        fetch("/api/home").then((res)=>res.json()).then((data)=>{
            const category = data.data?.hits && data.data?.hits.length ? data.data.hits.map((a, idx)=>{
                return {
                    name: a.name,
                    id: idx + 1
                };
            }) : [];
            // const filteredCategories = category.filter((item) =>
            //   [1, 2, 3, 6].includes(item.id)
            // );
            setAllCategories(category);
            setSelectedItem(category[0]?.name);
            setAllData(data.data?.hits);
        });
    };
    const filterByKey = (key)=>{
        if (key) {
            setLoading(true);
            const courses = [
                ...allData
            ].find((s)=>s.name === key)?.data;
            const all = courses.length ? courses.map((a, index)=>{
                return {
                    ...a,
                    skills: a.skills.length > 0 && a.skills.some((a)=>typeof a == "string") ? a.skills.map((a)=>{
                        return {
                            name: a,
                            slug: a
                        };
                    }) : a.skills
                };
            }) : [];
            setLoading(false);
            setAllCourse(all);
        }
    };
    const [animationClass, setAnimationClass] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (selectedItem) {
            setAnimationClass("slide-out");
            const slideOutTimer = setTimeout(()=>{
                filterByKey(selectedItem);
                setAnimationClass("slide-in");
            }, 500);
            const slideInTimer = setTimeout(()=>setAnimationClass(""), 1000);
            return ()=>{
                clearTimeout(slideOutTimer);
                clearTimeout(slideInTimer);
            };
        }
    }, [
        selectedItem
    ]);
    const propsTemplate = {
        title: {
            label: null,
            image_url: null
        },
        cardId: "Card-Course-Business",
        isLoading: false,
        error: null,
        trackId: "homepage_business"
    };
    const settings = {
        className: "swiper-customized-business",
        freeMode: true,
        navigation: true,
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 10
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 10
            },
            // when window width is >= 912px
            912: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 10
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 20
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (selectedItem) {
            filterByKey(selectedItem);
        }
    }, [
        selectedItem
    ]);
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    // Data doesn't returned from API
    if (!isLoading && (allCourse?.length == 0 || allCourse?.length == undefined)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    const isMobileView =  true && window.screen.width < 993;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "home-access",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
            useAuto: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-24 justify-center text-center pb-[52px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-h3 font-black text-neutral-80 sm-max:text-h4",
                                children: headingSectionAccess.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-h4 font-light text-neutral-70 md:px-240 sm-max:text-b1",
                                children: headingSectionAccess.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-24 w-full mt-24",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsCustom/* TabsCustom */.u, {
                                data: allCategories,
                                selectedItem: selectedItem,
                                onSelectItem: onSelectItem,
                                useMinWidth: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full overflow-hidden relative",
                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-full p-24 items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonLoader/* default */.Z, {})
                                }) : allCourse && allCourse.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: animationClass,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                        ...settings,
                                        cssMode: true,
                                        mousewheel: true,
                                        keyboard: true,
                                        modules: [
                                            swiper_esm/* Navigation */.W_,
                                            swiper_esm/* Pagination */.tl,
                                            swiper_esm/* Mousewheel */.Gk,
                                            swiper_esm/* Keyboard */.N1
                                        ],
                                        children: allCourse.map((course, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCourseWithLesson/* default */.Z, {
                                                    ...course,
                                                    index,
                                                    className: "card-default",
                                                    isLayoutNew: true,
                                                    isHorizontal: true,
                                                    onClickFunction: ()=>{
                                                        (0,gtag/* pushDataLayer */.zz)({
                                                            event: "course-access-home"
                                                        });
                                                        showPopupFormSales("");
                                                    }
                                                })
                                            }, "SwiperSlide" + index))
                                    })
                                }) : null
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/modules/Business/HomeContacts.tsx





const HomeContacts = ()=>{
    const headingSectionContact = business/* HomeContact */.un;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "home-contact",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
            useAuto: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative grid gap-24 text-center shadow-chip_total rounded-16 px-[16px] lg:px-[64px] py-[32px] bg-dark_purple_main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid gap-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                dangerouslySetInnerHTML: {
                                    __html: headingSectionContact.title
                                },
                                className: "text-t1 font-bold text-[#fff] lg-max:text-h3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "w-full text-h4 font-light text-white lg-max:text-b1",
                                children: headingSectionContact.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonScheduleDemo/* default */.Z, {
                            className: "!h-48",
                            id: "cta-bottom"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/bg_contact_1.svg",
                        alt: "bg_contact",
                        width: 224,
                        height: 224,
                        className: "absolute top-0 left-0 hidden lg:block"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/bg_contact_2.svg",
                        alt: "bg_contact",
                        width: 344,
                        height: 344,
                        className: "absolute bottom-0 right-0 hidden lg:block"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/IconCheckWithOuter.tsx


const IconCheckWithOuter = ({ size =14 , color ="#F37A41" , className =""  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Heroicons/Solid/badge-check",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Icon",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.3873 2.41837C4.83745 2.38245 5.26479 2.20544 5.60849 1.91254C6.41056 1.22902 7.59022 1.22902 8.39229 1.91254C8.73599 2.20544 9.16333 2.38245 9.61348 2.41837C10.6639 2.5022 11.4981 3.33635 11.5819 4.38681C11.6178 4.83696 11.7949 5.2643 12.0878 5.60801C12.7713 6.41007 12.7713 7.58974 12.0878 8.3918C11.7949 8.7355 11.6178 9.16285 11.5819 9.61299C11.4981 10.6635 10.6639 11.4976 9.61348 11.5814C9.16333 11.6174 8.73599 11.7944 8.39229 12.0873C7.59022 12.7708 6.41056 12.7708 5.60849 12.0873C5.26479 11.7944 4.83745 11.6174 4.3873 11.5814C3.33684 11.4976 2.50269 10.6635 2.41886 9.61299C2.38294 9.16285 2.20593 8.7355 1.91303 8.3918C1.22951 7.58974 1.22951 6.41007 1.91303 5.60801C2.20593 5.2643 2.38294 4.83696 2.41886 4.38681C2.50269 3.33635 3.33684 2.5022 4.3873 2.41837ZM9.59537 6.09488C9.86873 5.82151 9.86873 5.37829 9.59537 5.10493C9.322 4.83156 8.87878 4.83156 8.60542 5.10493L6.30039 7.40995L5.39537 6.50493C5.122 6.23156 4.67878 6.23156 4.40542 6.50493C4.13205 6.77829 4.13205 7.22151 4.40542 7.49488L5.80542 8.89488C6.07878 9.16824 6.522 9.16824 6.79537 8.89488L9.59537 6.09488Z",
                fill: color
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(9010);
;// CONCATENATED MODULE: ./src/modules/Business/packetStore.ts

const usePacketStore = (0,esm/* default */.ZP)((set)=>({
        // state
        PacketSelectedType: "Paket Tahun",
        TopUpSelectedType: "TopUp Tahun",
        isIncludeCertificate: false,
        isOpen: false,
        // actions
        setPacketSelectedType (item) {
            set({
                PacketSelectedType: item
            });
        },
        setTopUpSelectedType (item) {
            set({
                TopUpSelectedType: item
            });
        },
        setIncludeCertificate (item) {
            set({
                isIncludeCertificate: item
            });
        },
        setIsOpen (item) {
            set({
                isOpen: item
            });
        }
    }));

;// CONCATENATED MODULE: ./src/modules/Business/PricingTable.tsx


const columnName = [
    "<span></span>",
    "<span class='font-[700] font-[22px] text-violet_main'>ENTERPRISE</span>",
    "<span class='font-[700] font-[22px]'>ULTIMATE</span>"
];
const rowTitles = [
    "<span class='font-[500] font-[16px]'>Biaya Berlangganan dengan Pembayaran Tahunan</span><br/><span class='font-[300]'>(min 12 bulan)</span>",
    "<span class='font-[500] font-[16px]'>Biaya Berlangganan dengan Pembayaran Bulanan</span>",
    "<span class='font-[500] font-[16px]'>Jumlah Pengguna</span> <span class='font-[300]'>dari Satu Entitas Perusahaan, Instansi, atau Organisasi</span>",
    "<span class='font-[500] font-[16px]'>Jumlah Kursus dari Katalog Learnext</span><br/><span class='font-[300]'>(dari mitra Learnext dengan sertifikat resmi)</span>",
    "<span class='font-[500] font-[16px]'>Upload Video atau Konversi PPT Internal</span> <span class='font-[300]'>menjadi Kursus Digital dengan AI Learnext</span>",
    "<span class='font-[500] font-[16px]'>Total Durasi Diskusi Interaktif NEXA</span><br/><span class='font-[300]'>(berlaku untuk seluruh karyawan/anggota)</span>",
    "<span class='font-[500] font-[16px]'>Upload File Pengetahuan (Knowledge Base) Nexa</span><br/><span class='font-[300]'>(file dokumen, video, dan gambar)</span>",
    "<span class='font-[500] font-[16px]'>Data Dashboard Admin</span>"
];
const enterpriseContent = [
    "<span class='font-[700]'>IDR 50,000,000 per bulan</span><br/><span class='font-[300]'>(IDR 600,000,000 per tahun)</span>",
    "<span class='font-[500]'>IDR 63,000,000 per bulan</span>",
    "<span class='font-[700]'>TANPA BATAS<br/>(UNLIMITED LEARNERS)</span>",
    "<span class='font-[700]'>200 Kursus</span><br/><span class='font-[300]'>(Ditambah dan di-update otomatis tiap bulan)</span>",
    "<span class='font-[700]'>1.000 menit</span>",
    "<span class='font-[700]'>24.000 menit</span>",
    "<span class='font-[700]'>10GB</span>",
    "<span class='font-[700]'>Standar</span>"
];
const ultimateContent = [
    "<span class='font-[700]'>IDR 85,000,000 per bulan</span><br/><span class='font-[300]'>(IDR 1,020,000,000 per tahun)</span>",
    "<span class='font-[500]'>IDR 105,000,000 per bulan</span>",
    "<span class='font-[700]'>TANPA BATAS<br/>(UNLIMITED LEARNERS)</span>",
    "<span class='font-[700]'>1.000+ Kursus</span><br/><span class='font-[300]'>(Ditambah dan di-update otomatis tiap bulan)</span>",
    "<span class='font-[700]'>5.000 menit</span>",
    "<span class='font-[700]'>48.000 menit</span>",
    "<span class='font-[700]'>20GB</span>",
    "<span class='font-[700]'>Dapat disesuaikan</span>"
];
const PricingTable = ({ width  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `grid grid-cols-[43.75%_28.125%_28.125%] gap-0 rounded-[12px] overflow-hidden border border-[#E5E7EB] bg-[#FFFFFF]`,
        style: {
            width: width || "100%"
        },
        children: [
            columnName.map((col, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `px-[24px] py-[16px] ${i === 0 ? "border-b border-[#E5E7EB]" : i === 1 ? "border-l-[4px] border-r-[4px] border-t-[4px] border-b border-violet_main border-b-[#E5E7EB] flex items-center justify-center" : "border-b border-[#E5E7EB] flex items-center justify-center"}`,
                    dangerouslySetInnerHTML: {
                        __html: col
                    }
                }, i)),
            rowTitles.map((title, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `px-[24px] py-[16px] text-start ${i === rowTitles.length - 1 ? "" : "border-b"} border-[#E5E7EB]`,
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `px-[24px] py-[16px] border-l-[4px] border-r-[4px] border-violet_main ${i === rowTitles.length - 1 ? "border-b-[4px] border-b-violet_main" : "border-b border-b-[#E5E7EB]"} text-center`,
                            dangerouslySetInnerHTML: {
                                __html: enterpriseContent[i]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `px-[24px] py-[16px] ${i === rowTitles.length - 1 ? "" : "border-b"} border-[#E5E7EB] text-center`,
                            dangerouslySetInnerHTML: {
                                __html: ultimateContent[i]
                            }
                        })
                    ]
                }, i))
        ]
    });
};
/* harmony default export */ var Business_PricingTable = (PricingTable);

;// CONCATENATED MODULE: ./src/modules/Business/HomePackets.tsx








const HomePackets = ()=>{
    const headingSectionPackets = business/* HomePackets */.NI;
    // const [selectedType, setSelectedType] = useState("Tahun");
    // const [isOpen, setIsOpen] = useState(false);
    const [types, setTypes] = (0,react.useState)([
        {
            label: "Bulanan",
            value: "Paket Bulan",
            selected: false,
            child: null
        },
        {
            label: "Tahunan",
            value: "Paket Tahun",
            selected: true,
            child: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white flex justify-center items-center gap-2 px-6 py-2 rounded-12 text-orange-50 font-medium text-c1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckWithOuter, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Hemat 18%"
                    })
                ]
            })
        }
    ]);
    const { setSelectedType , isIncludeCertificate , setIncludeCertificate  } = usePacketStore((state)=>({
            setSelectedType: state.setPacketSelectedType,
            isIncludeCertificate: state.isIncludeCertificate,
            setIncludeCertificate: state.setIncludeCertificate
        }));
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "home-packets",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
            useAuto: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-24 justify-center text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid gap-8 mb-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-h3 font-black text-neutral-80 sm-max:text-h4",
                                children: headingSectionPackets.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-h4 font-light text-neutral-70 sm-max:text-b1",
                                children: headingSectionPackets.description
                            })
                        ]
                    }),
                    isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Business_PricingTable, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overflow-x-auto hide-scrollbar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Business_PricingTable, {
                            width: "1000px"
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/modules/Business/HomePopUp.tsx + 1 modules
var HomePopUp = __webpack_require__(9504);
// EXTERNAL MODULE: ./src/modules/Nav/BottomNav.tsx + 5 modules
var BottomNav = __webpack_require__(8559);
// EXTERNAL MODULE: ./src/components/Modal/index.tsx
var Modal = __webpack_require__(9177);
;// CONCATENATED MODULE: ./src/modules/Business/HomeInformation.tsx




const DataInfo = {
    industry: "200+",
    courses: "1.000+",
    learners: "700K+",
    partners: "50+",
    trainers: "50+"
};
const DataInformation = [
    {
        title: DataInfo.courses,
        description: `kursus-kursus soft skill & tren industri terkini dari ${DataInfo.partners} perusahaan dan universitas top dunia`
    },
    {
        title: DataInfo.learners,
        description: `jumlah pelajar yang menggunakan goKampus sebagai tempat pembelajaran`
    },
    {
        title: DataInfo.industry,
        description: `perusahaan dari berbagai industri yang telah menggunakan goKampus Business`
    }
];
const HomeInformation = ()=>{
    const { showPopupFormSales  } = usePopupStoreFormSales((state)=>({
            showPopupFormSales: state.showPopupFormSales
        }));
    const onClickImages = ()=>{
        pushDataLayer({
            event: "cta-partner"
        });
        showPopupFormSales("");
    };
    return /*#__PURE__*/ _jsx("section", {
        id: "home-information",
        children: /*#__PURE__*/ _jsx(ContainerDesktop, {
            className: "pt-20 pb-52 sm-max:py-36",
            useAuto: true,
            children: /*#__PURE__*/ _jsx("div", {
                className: "grid grid-cols-3 md-max:grid-cols-1 gap-16 ",
                children: DataInformation.map((value)=>/*#__PURE__*/ _jsxs("div", {
                        className: "shadow-chip_total p-24 rounded-16 bg-chip-pattern",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-h1 text-violet_main_to_dark_purple_surface font-bold",
                                children: value.title
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "font-light",
                                children: value.description
                            })
                        ]
                    }))
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Image/Image.tsx + 1 modules
var Image = __webpack_require__(2317);
;// CONCATENATED MODULE: ./src/modules/Business/HomeCompanies.tsx








const UserCompanies = [
    {
        name: "kemenperin",
        image_url: "https://staging-static.gokampus.com/course-institutions/PgSTbEwHeIaow3LoiMWJL9MCeEowfAqZbRMNFE2X.png"
    },
    {
        name: "pan-rb",
        image_url: "https://www.menpan.go.id/site/images/logo_new.png"
    },
    {
        name: "kapal-api",
        image_url: "https://s.gokampus.com/tenants/h7tBkxynkbFqEEsqmnlBIWLYqs9818UtqOP4TZzz.png"
    },
    {
        name: "bluebird",
        image_url: "https://s.gokampus.com/tenants/7p5nbeVAVOm0qMHWUU5UCafQ6vVp1E7sDS8SqRLG.png"
    },
    {
        name: "darya-varia",
        image_url: "https://s.gokampus.com/business/logo-darya-varia.png"
    },
    {
        name: "aquaproof",
        image_url: "https://s.gokampus.com/business/logo-aquaproof.png"
    },
    {
        name: "wonderful-indonesia",
        image_url: "https://s.gokampus.com/business/logo-wonderful-indonesia.png"
    },
    {
        name: "mega-insurance",
        image_url: "https://s.gokampus.com/business/logo-mega-insurance.png"
    },
    {
        name: "boga",
        image_url: "https://s.gokampus.com/business/logo-boga-red.png"
    },
    {
        name: "zap",
        image_url: "https://staging-static.gokampus.com/tenants/zVnouvLjX8dYIo3SeFsveyPrtgKtPjvvJ3bWjIIg.jpeg"
    },
    {
        name: "summarecon-agung",
        image_url: "https://s.gokampus.com/business/logo-summarecon-agung.png"
    },
    {
        name: "indosat-digital-ecosystem",
        image_url: "https://staging-static.gokampus.com/course-institutions/qxPa26tOotbk4UDG3tiKhDjWrd9wv7XCPPXZ2S0E.png"
    },
    {
        name: "ppsdm-aparatur-esdm",
        image_url: "https://s.gokampus.com/tenants/WlnVzEy7CcF5VWTrd0IZIi1LDYBY4glIMr9WG71j.jpeg"
    },
    {
        name: "sucor-sekuritas",
        image_url: "https://staging-static.gokampus.com/course-institutions/6FDrcHmhLJzGSi4cqk2YMsDMHhwbFgBF0xSl1lxl.svg"
    },
    {
        name: "arwana-ceramics",
        image_url: "https://s.gokampus.com/business/logo-arwana-ceramics.png"
    },
    {
        name: "tdr",
        image_url: "https://s.gokampus.com/business/logo-tdr.png"
    },
    {
        name: "blibli",
        image_url: "https://s.gokampus.com/tenants/eNiPV814LTbT43yfGqQrMfYWUBfKUdVRTe2w2ZHx.png"
    },
    {
        name: "emtek",
        image_url: "https://s.gokampus.com/business/logo-emtek.png"
    }
];
const DoubledUserCompanies = [
    ...UserCompanies,
    ...UserCompanies
];
const HomeCompanies = ()=>{
    const [scrollPosition, setScrollPosition] = (0,react.useState)(0);
    const textCompanies = business/* HomeCompanies */.yX;
    const { showPopupFormSales  } = (0,popupStore/* usePopupStoreFormSales */.p)((state)=>({
            showPopupFormSales: state.showPopupFormSales
        }));
    (0,react.useEffect)(()=>{
        const scrollSpeed = 1;
        const scrollInterval = 30;
        const interval = setInterval(()=>{
            setScrollPosition((prevPosition)=>{
                const newPosition = prevPosition + scrollSpeed;
                const containerWidth = UserCompanies.length * 200;
                return newPosition >= containerWidth ? 0 : newPosition;
            });
        }, scrollInterval);
        return ()=>clearInterval(interval);
    }, []);
    const onClickImages = ()=>{
        (0,gtag/* pushDataLayer */.zz)({
            event: "cta-client"
        });
        showPopupFormSales("");
    };
    const onClickSeeMore = ()=>{
        (0,gtag/* pushDataLayer */.zz)({
            event: "cta-client-see-more"
        });
        showPopupFormSales("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "home-companies",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
            useAuto: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-36 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-b2 font-medium lg:text-h3 lg:font-black text-neutral-80 lg-max:text-h4",
                        dangerouslySetInnerHTML: {
                            __html: DataInfo.industry + " " + textCompanies.title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative overflow-hidden cursor-pointer shadow-chip_total py-20 bg-white rounded-16",
                        onClick: onClickImages,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex whitespace-nowrap transition-transform duration-100",
                            style: {
                                transform: `translateX(-${scrollPosition}px)`
                            },
                            children: DoubledUserCompanies.map((institution, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inline-flex aspect-[2/1] items-center justify-center bg-white px-16 py-16",
                                    style: {
                                        minWidth: "200px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: institution.image_url,
                                        alt: institution.name,
                                        className: "w-full h-full object-contain"
                                    })
                                }, `${institution.name}-${index}`))
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeaderPricing.tsx



const PageHeaderPricing = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "z-50 h-108 sticky top-72 lg-max:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
            useAuto: true
        })
    });
};
/* harmony default export */ var PageHeader_PageHeaderPricing = (PageHeaderPricing);

// EXTERNAL MODULE: ./src/components/Divider/Divider.tsx
var Divider = __webpack_require__(2790);
;// CONCATENATED MODULE: ./src/modules/Business/HomeTestimony.tsx









swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Pagination */.tl
]);
const HomeTestimony = ()=>{
    const wordingTestimony = business/* HomeTestimony */.yt;
    const settings = {
        slidesPerView: 1,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        allowTouchMove: false,
        loop: true,
        speed: 2000,
        pagination: true
    };
    const settingsSwiperCard = {
        spaceBetween: 20,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        speed: 2000,
        loop: true
    };
    const { showPopupFormSales  } = (0,popupStore/* usePopupStoreFormSales */.p)((state)=>({
            showPopupFormSales: state.showPopupFormSales
        }));
    const onClickItem = ()=>{
        (0,gtag/* pushDataLayer */.zz)({
            event: "cta-testimony"
        });
        showPopupFormSales("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "home-testimony",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* ContainerDesktop */.h, {
            useAuto: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sg-max:hidden relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        loop: true,
                        loopedSlides: 2,
                        navigation: true,
                        speed: 2000,
                        watchSlidesProgress: true,
                        autoplay: {
                            delay: 15000,
                            disableOnInteraction: false
                        },
                        modules: [
                            swiper_esm/* Navigation */.W_,
                            swiper_esm/* Keyboard */.N1,
                            swiper_esm/* Autoplay */.pt
                        ],
                        className: "mySwiper swiper-customized",
                        children: [
                            wordingTestimony.testimonies,
                            wordingTestimony.testimonies
                        ].flat().map((testimony, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "h-[442px] flex flex-col gap-16 p-24 bg-total-pattern rounded-12 border border-[#F3F4F6] bg-white",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                    src: testimony.urlPeople,
                                                    alt: testimony.name,
                                                    className: "w-[72px] object-contain rounded-16"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                    src: testimony.urlInstitution,
                                                    alt: testimony.title,
                                                    /// Since migrating to AWS, every "height"/"width" attribute
                                                    /// need to convert to className as "max-h"/"max-w" attribute
                                                    // height={70}
                                                    className: "object-contain max-h-[72px]"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-b1",
                                                    children: [
                                                        " ",
                                                        testimony.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-b2 font-light",
                                                    children: testimony.job
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                                            className: "hidden sg-max:block border-neutral20_to_dark30"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-b1 font-light",
                                            children: [
                                                '"',
                                                testimony.body,
                                                '"'
                                            ]
                                        })
                                    ]
                                })
                            }, index))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hidden sg-max:block relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 left-0 z-10 w-full h-[672px] bg-transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            slidesPerView: 1,
                            spaceBetween: 20,
                            loop: true,
                            loopedSlides: 1,
                            navigation: true,
                            pagination: {
                                clickable: true,
                                dynamicBullets: true
                            },
                            speed: 2000,
                            watchSlidesProgress: true,
                            autoplay: {
                                delay: 15000,
                                disableOnInteraction: false
                            },
                            modules: [
                                swiper_esm/* Navigation */.W_,
                                swiper_esm/* Pagination */.tl,
                                swiper_esm/* Keyboard */.N1,
                                swiper_esm/* Autoplay */.pt
                            ],
                            className: "mySwiper swiper-customized hide-scrollbar relative",
                            children: wordingTestimony.testimonies.map((testimony, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    onClick: onClickItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "h-[672px] flex flex-col gap-16 p-24 bg-total-pattern rounded-12 border border-[#F3F4F6] bg-white",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                        src: testimony.urlPeople,
                                                        alt: testimony.name,
                                                        className: "w-[72px] object-contain rounded-16"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                        src: testimony.urlInstitution,
                                                        alt: testimony.title,
                                                        /// Since migrating to AWS, every "height"/"width" attribute
                                                        /// need to convert to className as "max-h"/"max-w" attribute
                                                        // height={70}
                                                        className: "object-contain max-h-[72px]"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-b1",
                                                        children: [
                                                            " ",
                                                            testimony.name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-b2 font-light",
                                                        children: testimony.job
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                                                className: "hidden sg-max:block border-neutral20_to_dark30"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-b1 font-light",
                                                dangerouslySetInnerHTML: {
                                                    __html: testimony.body
                                                }
                                            })
                                        ]
                                    })
                                }, testimony.name + i))
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Form/FieldText.tsx + 3 modules
var FieldText = __webpack_require__(3726);
// EXTERNAL MODULE: ./src/modules/Business/businessApi.ts
var businessApi = __webpack_require__(1418);
// EXTERNAL MODULE: ./src/components/Toast/toastStore.ts
var toastStore = __webpack_require__(2505);
// EXTERNAL MODULE: ./src/modules/Course/CourseVideoJs.tsx + 5 modules
var CourseVideoJs = __webpack_require__(5712);
;// CONCATENATED MODULE: ./src/modules/Business/VideoPopUp.tsx










const VideoPopUp = ({ eventId ="popup-video"  })=>{
    const textDocs = business/* PopupFormSales */.fG;
    const { closePopupFormSales  } = (0,popupStore/* usePopupStoreFormSales */.p)((state)=>({
            closePopupFormSales: state.closePopupFormSales,
            currentCtaEvent: state.currentCtaEvent
        }));
    const [contact, setcontact] = (0,react.useState)("");
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const showToast = (0,toastStore/* useToastStore */.E)((state)=>state.showToast);
    const usePostApi = (0,businessApi/* usePostContactBusiness */.g)();
    const submit = ()=>{
        setIsLoading(true);
        if (!contact) {
            showToast({
                type: "danger",
                message: "Pastikan kontak anda sudah diisi"
            });
            setIsLoading(false);
            return;
        }
        const urlOrigin = window.location.href + "?event=" + eventId;
        usePostApi.doFetch({
            contact,
            url_origin: urlOrigin
        }, {
            onSuccess (res) {
                (0,gtag/* pushDataLayer */.zz)({
                    event: "success-leads"
                });
                closePopupFormSales();
                // reset form field
                setcontact("");
                //@ts-ignore
                if (res.message === "success") {
                    showToast({
                        type: "success",
                        message: "Email anda berhasil terkirim ke tim goKampus"
                    });
                    setIsLoading(false);
                }
            },
            onError (err) {
                showToast({
                    type: "danger",
                    message: err.data?.message ?? err.message ?? "Error"
                });
                setIsLoading(false);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: textDocs.title
                },
                className: "font-black text-h2 lg-max:text-h3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "items-center grid grid-cols-2 gap-x-[42px] lg-max:grid-cols-1 2xl-max:gap-y-[42px] h-full justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full h-[50vh]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseVideoJs.VideoJS, {
                            url: "https://s.gokampus.com/business/intro-gokampus-nov-2023.mp4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "!bg-white flex flex-col gap-8 shadow-chip_total rounded-16 bg-chip-pattern p-32",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-black text-h3 lg-max:text-h5",
                                    children: textDocs.contactSales
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-light text-b1 sm-max:text-b1 py-4",
                                    children: textDocs.contactSalesDesc
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-medium text-b2 text-neutral-60",
                                    children: textDocs.fieldContactInput
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldText/* default */.Z, {
                                    name: "contact",
                                    islast: true,
                                    classBase: "h-full sm-max:w-full !mb-16",
                                    inputStyle: "!rounded-8 h-40 sm-max:!w-full",
                                    placeholder: textDocs.fieldContactPlaceholder,
                                    value: contact,
                                    onChange: (e)=>setcontact(e.target.value)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: `flex justify-center items-center gap-8 !rounded-8 !text-b1`,
                                    onClick: ()=>{
                                        (0,gtag/* pushDataLayer */.zz)({
                                            event: eventId
                                        });
                                        submit();
                                    },
                                    isFull: true,
                                    state: isLoading ? "loading" : "active",
                                    children: textDocs.fieldSubmit
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx



















const HomeBusiness = ()=>{
    const [modeTransparent, setMode] = (0,react.useState)(true);
    const [isShowHeaderPricing, setisShowHeaderPricing] = (0,react.useState)(false);
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    const scrollOffset = isDesktop ? 90 : 56;
    const { isShow , closePopupFormSales , isShowYoutubeModal , closePopupYoutube  } = (0,popupStore/* usePopupStoreFormSales */.p)((state)=>({
            isShow: state.isShow,
            closePopupFormSales: state.closePopupFormSales,
            isShowYoutubeModal: state.isShowYoutubeModal,
            closePopupYoutube: state.closePopupYoutube
        }));
    const pricingRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        function onScroll(e) {
            if (window.scrollY >= scrollOffset) {
                setMode(false);
            } else if (window.scrollY < scrollOffset) {
                setMode(true);
            }
            // Calculate the scroll threshold dynamically based on the reference element's position
            if (pricingRef.current) {
                //@ts-ignore
                let referenceElementPosition = pricingRef.current.getBoundingClientRect();
                let scrollThreshold = window.innerHeight - (referenceElementPosition.top + 800);
                if (scrollThreshold > 0 && scrollThreshold < 550) {
                    // Show the component when the scroll position is greater than or equal to the threshold
                    setisShowHeaderPricing(true);
                } else {
                    // Hide the component when the scroll position is less than the threshold
                    setisShowHeaderPricing(false);
                }
            }
        }
        window.addEventListener("scroll", onScroll);
        return ()=>window.removeEventListener("scroll", onScroll);
    }, []);
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: "https://unpkg.com/swiper@7/swiper-bundle.min.css"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                itemProp: "thumbnailUrl",
                href: "/icon-meta.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                itemProp: "thumbnail",
                itemScope: true,
                itemType: "http://schema.org/ImageObject",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    itemProp: "url",
                    href: "/icon-meta.png"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeaderBusiness/* default */.Z, {
                isTransparent: modeTransparent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "lg:bg-[url('/bg-lp-desktop.svg')] lg:bg-no-repeat lg:bg-cover lg:bg-center",
                children: [
                    isShowHeaderPricing && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader_PageHeaderPricing, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-[12px] lg:px-[80px] bg-gradient-to-b from-[#F3EBFF99] to-[#FFFFFF99]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[52px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeDescription, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[104px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCompanies, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[104px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeBenefit, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[104px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeAccess, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-[12px] lg:px-[80px] bg-gradient-to-b from-[#F3EBFF99] to-[#FFFFFF99]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[52px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePackets, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[104px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTestimony, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[104px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeContacts, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[104px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBusiness/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        className: "bg-[url('/images/image-bg-desktop.webp')] bg-no-repeat bg-cover sm-max:bg-[url('/images/image-bg-mobile.webp')]",
                        contentClassName: "!bg-transparent",
                        childrenClassName: "lg:h-[85vh] lg:flex",
                        color: BottomNav/* iconColor.default */.e["default"],
                        isShow: isShowYoutubeModal,
                        onClose: closePopupYoutube,
                        isFullScreen: true,
                        isTopBorderTransparent: true,
                        isWidthScreen: "90vw",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPopUp, {})
                    }, "modal-youtube"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        className: "flex items-center justify-center bg-[url('/images/image-bg-desktop.webp')] bg-no-repeat bg-cover sm-max:bg-[url('/images/image-bg-mobile.webp')]",
                        contentClassName: "!bg-transparent",
                        childrenClassName: "lg:h-[80vh] lg:flex",
                        color: BottomNav/* iconColor.default */.e["default"],
                        isShow: isShow,
                        onClose: closePopupFormSales,
                        isFullScreen: true,
                        isTopBorderTransparent: true,
                        isWidthScreen: "90vw",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePopUp/* HomePopUp */.$, {})
                    }, "modal-popup-sales")
                ]
            })
        ]
    });
};
/* harmony default export */ var pages = (HomeBusiness);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [544,412,422,562,458,180,289,292,631,541,864,517,894,658,504,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);